import {Box, HStack, Link, Text, VStack} from "@chakra-ui/react";
import dayjs from "dayjs";
import React from "react";

export const PositionsList = ({positions}) => {
    return (
        <VStack gap={2} align={'stretch'} my={2}>
            {positions.map((pos, i) => (
                    <Box key={i} bg={'gray.800'} borderRadius={'sm'} p={2} borderWidth={1} borderColor={'gray.700'}
                         w={'full'}>
                        <Text fontSize={14} fontWeight={700}>#{i + 1} {pos.positionName}</Text>
                        {/*<Text fontSize={13} color={'gray.300'}>{pos.clientName}</Text>*/}
                        <HStack fontSize={12} color={'gray.400'} justify={'space-between'}>
                            <Text>{dayjs(pos.startDate).format('DD MMM YYYY')} → {pos.endDate ? dayjs(pos.endDate).format('DD MMM YYYY') : 'present'}</Text>
                            <Text>{pos.hourlyRate} €/h</Text>
                        </HStack>
                    </Box>
            ))}
        </VStack>
    );
};
